import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface MediaUploadResponse {
  id: number;
  fileName: string;
  contentType: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  private readonly apiUrl = environment.apiUrl + '/media';

  constructor(private readonly http: HttpClient) {}

  uploadImage(file: File): Observable<MediaUploadResponse> {
    const formData = new FormData();

    formData.append('file', file);

    return this.http.post<MediaUploadResponse>(
      this.apiUrl,
      formData,
      {
        withCredentials: true
      }
    );
  }
}